// extracted by mini-css-extract-plugin
export default {"root":"dc2QKsBx7D56hq7kW2qs","name-label":"dL3zzlHRZts342MRZzjt","group-avatar":"W_7zrIZzKnNaw1MilYH_","default-group":"Zl9yJu3yrSjwlVoa9gO9"};